import { render, staticRenderFns } from "./FAQDealsComponent.vue?vue&type=template&id=43be5ec8&scoped=true&"
import script from "./FAQDealsComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQDealsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQDealsComponent.vue?vue&type=style&index=0&id=43be5ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be5ec8",
  null
  
)

export default component.exports